import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { route } from "./static/route";
import LoginPage from "./pages/login";
import NotFoundPage from "./pages/notFound";
import DashboardPage from "./pages/dashboard";
import PrivateRoute from "./components/route/PrivateRoute";
import NewOrderPage from "./pages/newOrder";
import NewOrderListPage from "./pages/newOrderList";
import ClosedOrderListPage from "./pages/closedOrderList";
import OpenOrderListPage from "./pages/openOrderList";
import OrderDetailsPage from "./pages/orderDetails";
import NewJobworkPage from "./pages/newJobwork";
import NewJobworkListPage from "./pages/newJobworkList";
import OpenJobworkListPage from "./pages/openJobworkList";
import JobworkDetailsPage from "./pages/jobworkDetails";
import ClosedJobworkListPage from "./pages/closedJobworkList";
import NewSamplePage from "./pages/newSample";
import OpenSampleListPage from "./pages/openSampleList";
import SampleDetailsPage from "./pages/sampleDetails";
import ClosedSampleListPage from "./pages/closedSampleList";

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path={route.login} element={<LoginPage />} />

        <Route
          path={route.dashboard}
          element={
            <PrivateRoute element={<DashboardPage />} path={route.login} />
          }
        />

        <Route
          path={route.newOrder}
          element={
            <PrivateRoute element={<NewOrderPage />} path={route.login} />
          }
        />

        <Route
          path={route.newOrderList}
          element={
            <PrivateRoute element={<NewOrderListPage />} path={route.login} />
          }
        />

        <Route
          path={route.openOrder}
          element={
            <PrivateRoute element={<OpenOrderListPage />} path={route.login} />
          }
        />

        <Route
          path={route.closedOrder}
          element={
            <PrivateRoute
              element={<ClosedOrderListPage />}
              path={route.login}
            />
          }
        />

        <Route
          path={route.orderDetails + "/:orderId"}
          element={
            <PrivateRoute element={<OrderDetailsPage />} path={route.login} />
          }
        />

        <Route
          path={route.newJobwork}
          element={
            <PrivateRoute element={<NewJobworkPage />} path={route.login} />
          }
        />

        <Route
          path={route.newJobworkList}
          element={
            <PrivateRoute element={<NewJobworkListPage />} path={route.login} />
          }
        />

        <Route
          path={route.openJobwork}
          element={
            <PrivateRoute
              element={<OpenJobworkListPage />}
              path={route.login}
            />
          }
        />

        <Route
          path={route.jobworkDetails}
          element={
            <PrivateRoute element={<JobworkDetailsPage />} path={route.login} />
          }
        />

        <Route
          path={route.closedJobwork}
          element={
            <PrivateRoute
              element={<ClosedJobworkListPage />}
              path={route.login}
            />
          }
        />

        <Route
          path={route.newSample}
          element={
            <PrivateRoute element={<NewSamplePage />} path={route.login} />
          }
        />

        <Route
          path={route.openSample}
          element={
            <PrivateRoute element={<OpenSampleListPage />} path={route.login} />
          }
        />

        <Route
          path={route.sampleDetails + "/:sampleId"}
          element={
            <PrivateRoute element={<SampleDetailsPage />} path={route.login} />
          }
        />

        <Route
          path={route.closedSample}
          element={
            <PrivateRoute
              element={<ClosedSampleListPage />}
              path={route.login}
            />
          }
        />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  );
};
export default App;
